import { faList } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SearchBox from 'components/common/SearchBox';
import ToggleViewButton from 'components/common/ToggleViewbutton';
import FourGrid from 'components/icons/FourGrid';
import { ChangeEvent, useCallback } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import debounce from 'lodash/debounce';

interface ProjectsTopSectionInterface {
  activeView: 'list' | 'card';
  onSearch?: (term: string) => void;
}

const ArchiveProjectsTopSection = ({
  activeView,
  onSearch
}: ProjectsTopSectionInterface) => {
  const navigate = useNavigate();

  const debouncedSearch = useCallback(
    debounce((value: string) => {
      onSearch?.(value);
    }, 300),
    [onSearch]
  );

  const handleSearchInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    e.persist();
    debouncedSearch(e.target.value);
  };

  return (
    <Row className="g-3 justify-content-between align-items-center mb-4">
      <Col xs={12} sm="auto">
        <div className="d-flex align-items-center gap-1">
          <SearchBox
            onChange={handleSearchInputChange}
            placeholder="Search Jobs"
            style={{ maxWidth: '30rem' }}
            className="me-3"
          />
          <ToggleViewButton
            tooltip="List view"
            active={activeView === 'list'}
            onClick={() => {
              navigate('/home/apps/job/archive-list-view');
            }}
          >
            <FontAwesomeIcon icon={faList} className="fs-10" />
          </ToggleViewButton>
          <ToggleViewButton
            tooltip="Card view"
            active={activeView === 'card'}
            onClick={() => {
              navigate('/home/apps/job/archive');
            }}
          >
            <FourGrid />
          </ToggleViewButton>
        </div>
      </Col>
    </Row>
  );
};

export default ArchiveProjectsTopSection;
